(ns expenses.views
  (:require
    [reagent.core :as r]
    [reagent.format :as fmt]
    [very.re-frame.core :as rf]
    [main.common :as common]
    [util.core :refer [long-str string->float]]
    [css.form :as form]
    [css.core :refer [defstyled]]
    [profile.common :as pc]))

(defn manage [{:keys [on-save on-cancel cancel-label] :or {cancel-label "Cancel"}}]
  (let [expenses (rf/subscribe [:expenses])
        total (rf/subscribe [:profile/total-expenses])
        tmp @expenses
        f (atom nil)
        gather (fn [e]
                 (.preventDefault e)
                 (let [expenses (reduce
                                  (fn [m k] (assoc m k (string->float (.-value (get @f k)))))
                                  {}
                                  (keys tmp))]
                   (on-save expenses)))]
    (fn []
      [common/form-page-s
       [common/form-s  {:on-submit gather}
        [common/form-header-s
         [common/form-title-s {:margin "45px 0 0"} "Expenses"]
         [common/form-explain-s "Expenses include both living expenses and outstanding debt and loans. Understanding your expenses from both a monthly and annual perspective helps set a budget as well as provides guidance for how to approach your personal financial plan."]]
        [pc/form-section-s
         [pc/form-section-header-s
          [pc/form-section-title-s "Monthly living expenses"]
          [pc/form-section-total-s "Total: " (fmt/currency-format @total)]]
         [pc/form-section-description-s "The money that you spend each month on things like utilities, groceries and entertainment are considered to be your monthly living expenses. This also includes recurring loan payments such as your mortgage, student loans or other debt. If you do not have one of the following expenses, you can leave that section blank."]]

        [pc/column-wrapper-s {:margin "45px 0 0"}
         [pc/form-column-s
          [form/input-row-s {:currency? true}
           [form/input-label-s "Mortgage + property tax"]
           [form/input {:type "number"
                        :label? true
                        :unit? true
                        :max-width "100%"
                        :default-value (:mortgage tmp)
                        :min 0
                        :step 0.01
                        :ref #(swap! f assoc :mortgage %)}]]
          [form/input-row-s {:currency? true}
           [form/input-label-s "Tuition"]
           [form/input {:type "number"
                        :label? true
                        :unit? true
                        :max-width "100%"
                        :default-value (:tuition tmp)
                        :min 0
                        :step 0.01
                        :ref #(swap! f assoc :tuition %)}]]
          [form/input-row-s {:currency? true}
           [form/input-label-s "Recurring payments (car loans, etc.)"]
           [form/input {:type "number"
                        :label? true
                        :unit? true
                        :max-width "100%"
                        :default-value (:recurring-payments tmp)
                        :min 0
                        :step 0.01
                        :ref #(swap! f assoc :recurring-payments %)}]]]
         [pc/form-column-s
          [form/input-row-s {:currency? true}
           [form/input-label-s "Recurring expenses (utilities, groceries, etc.)"]
           [form/input {:type "number"
                        :label? true
                        :unit? true
                        :max-width "100%"
                        :default-value (:recurring-expenses tmp)
                        :min 0
                        :step 0.01
                        :ref #(swap! f assoc :recurring-expenses %)}]]
          [form/input-row-s {:currency? true}
           [form/input-label-s "Entertainment"]
           [form/input {:type "number"
                        :label? true
                        :unit? true
                        :max-width "100%"
                        :default-value (:entertainment tmp)
                        :min 0
                        :step 0.01
                        :ref #(swap! f assoc :entertainment %)}]]]]
        [form/button-row-s
         [form/secondary-button-s {:type "button"
                                   :on-click on-cancel} cancel-label]
         [form/button {:type "submit"} "Save"]]]])))

(defn summary [total {:keys [on-edit]}]
  [:div
   [common/profile-section-header {:link on-edit
                                   :text "Edit"
                                   :title "Expenses"}]
   (if total
     [:div
      [common/data-row-full {:label "Monthly living expenses:"
                             :value (fmt/currency-format total)}]]
     [common/no-results
      {:text (long-str "Tuition, mortgage, loans...they all add up! "
                       "Input your monthly and annual expenses so we can make the most of the money you have coming in and going out.")
       :button-text "Enter your expenses"
       :button-click on-edit}])])
